import { useTheme } from '@mui/material';
import { SVGProps } from 'react';

export const MenuIcon = (props: SVGProps<SVGSVGElement>) => {
  const theme = useTheme();

  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={24}
      height={24}
      fill="none"
      {...props}
    >
      <g
        stroke={theme.palette.action.active}
        strokeLinecap="round"
        strokeWidth={1.5}
      >
        <path d="M3.6 18h16.8M3.6 12h16.8M3.6 6h16.8" />
      </g>
    </svg>
  );
};
